import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, of } from 'rxjs'
import { Router} from '@angular/router';

import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

import { CommonService} from '../common.service'
import { SharedService } from '../shared.service'

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class  HomeComponent implements OnInit {

  homeAddress;
  mobile = false;

  constructor(private commonService: CommonService, private sharedService: SharedService, private router: Router, private modalService:NgbModal){
   /* this.searchText = {};
    var homeAddr = sharedService.getHomeAddress(); console.log("sharedService.getHomeAddress() in home constr-", homeAddr);
    if (homeAddr) {
      this.searchText.text = JSON.parse(homeAddr).homeAddress; console.log("this.searchTextin home constr2222222222-", this.searchText);
    }*/
  }

  ngOnInit() {
    if (this.sharedService.getHomeAddress()){
      //address is already selected
    }
    else {
      if (navigator && navigator.geolocation) {
        var locationOptions = {
          enableHighAccuracy: false,
          maximumAge: 10,
          timeout: 10000
        };
        var localThis = this;
        var storeCoordinates = function (position) {
          console.log("Location Coords::", position.coords.latitude, position.coords.longitude);
          if (position.coords.latitude && position.coords.longitude) {
            var revAddr;
            localThis.commonService.getReverseGeocode(position.coords.latitude, position.coords.longitude).subscribe(
              addr => {
                revAddr = addr;
                console.log("address", revAddr.address, 22, revAddr.address.Match_addr, 44, revAddr.location);
                localThis.commonService.getAddresses(revAddr.address.Match_addr).subscribe(
                  addr => {
                   console.log("addr from getAddresses TEST", addr);
                    revAddr = addr.suggestions[0];
                    localThis.sharedService.setHomeAddress(JSON.stringify(revAddr));
                  },
                  err => console.error("Error inside getReverseGeocode() call::", err),
                  () => {
                    //if (revAddr) {
                    // this.searchText = revAddr;
                    console.log("this.searchText--", this.searchText);
                    //}
                  });
              });
          }
        };
        var errorHandler = function (error) {
          if (error && error.code == error.PERMISSION_DENIED)
            console.log("Location permission is denied..", error);
          else
            console.log("Error in navigator.geolocation.getCurrentPosition call", error)
        };
        navigator.geolocation.getCurrentPosition(storeCoordinates, errorHandler, locationOptions);
      }
      else {
        console.log("Geolocation is not supported by this browser.");
      }
    }

    if (window.screen.width <768) { // 768px portrait
      this.mobile = true;
    }
  }

  public goToDOH() {
    //this.searchText = this.sharedService.getHomeAddress();
    this.sharedService.setPwsId(null);
    this.sharedService.setLatLngFrESRIMap(null);
    this.sharedService.setFlowFlag2Lat(null);
    this.sharedService.setFlowFlag2Lng(null);
    //this.sharedService.setFlowFlag("DOH");
    this.router.navigate(['/waterSystems']);
  }

  public goToDEC(){
    //this.searchText = this.sharedService.getHomeAddress();
    this.sharedService.setPwsId(null);
    this.sharedService.setLatLngFrESRIMap(null);
    this.sharedService.setFlowFlag2Lat(null);
    this.sharedService.setFlowFlag2Lng(null);
    //this.sharedService.setFlowFlag("DEC");
    this.router.navigate(['/waterMaps']);
  }

  open(content) {
    this.modalService.open(content, { size: 'lg', windowClass: 'modal-adaptive'});
  }
}
